export default class StudioModalController {

    constructor($scope, $injector, $uibModalInstance, studioInformation, user) {
        this.scope = $scope;
        this.injector = $injector;
        this.modalInstance = $uibModalInstance;
        this.studioInformation = studioInformation;
        this.user = user;
        this.timeout = $injector.get('$timeout');
        this.auth = $injector.get('$auth');

        this.angularState = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    $onInit() {
        this.timeout(() => {
            this._initIFrame();
        }, 0);
    }

    _initIFrame() {
        const iFrameDocument = document.getElementById('studio-iframe').contentWindow.document;
        let form = iFrameDocument.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", this.studioInformation._links.auth);
        form.setAttribute("target", "_self");
        let tokenField = iFrameDocument.createElement("input");
        tokenField.setAttribute("type", "hidden");
        tokenField.setAttribute("name", "token");
        tokenField.setAttribute("value", this.auth.getToken());

        const {id, email, full_name} = this.user;
        let userField = iFrameDocument.createElement("input");
        userField.setAttribute("type", "hidden");
        userField.setAttribute("name", "user");
        userField.setAttribute("value", JSON.stringify({id, email, full_name}));

        form.appendChild(tokenField);
        form.appendChild(userField);

        iFrameDocument.body.appendChild(form);
        form.submit();
    }
}

StudioModalController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance',
    'studioInformation',
    'user'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/controllers/modals/studio-modal-controller.js